import { useTranslation } from 'react-i18next';

import { useEventLogging } from '@innovamat/event-logging';
import { Button } from '@innovamat/glimmer-components';

type Props = {
  testRoundId: string;
  onClick: (testRoundId: string) => void;
  testId: string;
  classroomId: string;
};

const OpenTestReportCell = ({
  testRoundId,
  onClick,
  testId,
  classroomId,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { setEventData } = useEventLogging();

  const handleClick = () => {
    setEventData('test_report_click', {
      test_id: testId,
      round_id: testRoundId,
      class_id: classroomId,
    });

    onClick(testRoundId);
  };

  return (
    <Button
      className="open-drawer-button"
      leftIcon="SideDrawerIcon"
      variant="secondary"
      size="S"
      onClick={handleClick}
    >
      {t('common.open')}
    </Button>
  );
};

export { OpenTestReportCell };
